// firstRunPresetLine.js — the Workspace Presets' ONE entry point for a
// workspace that skipped them (wt/presets CONTRACT §5 WIZARD; the
// orchestrator's ruling 2026-10-24: a LEAD-IN LINE of the first-run block,
// never a step). The block's steps mirror the SERVER's activation rule
// (functions/assistantFlyFirstRun.js: the server decides every step, count,
// bar and window — the client computes nothing of it), so this line is not
// one of them: no tick, not counted, above the steps — "Set up for your work
// — start from a preset" — and its press opens the App Store, whose first row
// is the presets (the store's own sheet shows a preset and applies it).
//
// Shown only while ALL hold:
//   - the block is OPEN: not activated, inside the window, not hidden by the
//     person (the block's own X hides the line with it)
//   - the person may apply a preset (workspacePresetCanApply: owner / admin)
//   - the workspace has no `settings.preset` (a `custom` answer is an answer:
//     the line stays away)
//   - this host's SDK can apply presets, and the registry offers one the store
//     has words for (the store's row is not empty)
//
// FRANK: every export is self-contained; siblings through `this.call`.

// The line's question — pure over `root` (`now` is the block's own test seam).
export function assistantFlyFirstRunPresetLine(root, now) {
  const el = this
  const r = root && typeof root === 'object' ? root : {}
  const fns = (el && el.context && el.context.functions) || {}
  // every key the answer depends on, read first (reactive callers)
  void r._flyFirstRun
  void r.userPrefs
  void r.workspace
  void r.org
  void r._workspacePresets
  const unsupported = !!r._workspacePresetsUnsupported
  if (
    typeof fns.workspacePresetCanApply !== 'function' ||
    typeof fns.workspacePresetApplied !== 'function' ||
    typeof fns.workspacePresetsFeatured !== 'function' ||
    typeof fns.workspacePresetText !== 'function'
  ) {
    return false
  }
  if (unsupported) return false
  const view = el.call('assistantFlyFirstRunView', r, now) || {}
  if (!view.show || view.mode !== 'open') return false
  if (!el.call('workspacePresetCanApply', r)) return false
  if (el.call('workspacePresetApplied', r)) return false
  return (el.call('workspacePresetsFeatured', r) || []).some(
    (p) => !!p && !!el.call('workspacePresetText', p.key, 'name')
  )
}

// The line's prime (its onRender and every stateDeps change): while the start
// screen SHOWS, for a person the line can be for, the registry is read (five
// minutes held) — the read also settles whether this host's SDK can apply
// presets. A hidden start screen asks nothing.
export function assistantFlyFirstRunPresetPrime(el, s) {
  const host = el || this
  const root = (s && s.root) || (host && host.state && host.state.root) || null
  const fns = (host && host.context && host.context.functions) || {}
  if (!host || typeof host.call !== 'function' || !root) return false
  if (
    typeof fns.workspacePresetsLoad !== 'function' ||
    typeof fns.workspacePresetCanApply !== 'function' ||
    typeof fns.workspacePresetApplied !== 'function'
  ) {
    return false
  }
  if (typeof fns.assistantFlyStartShown === 'function') {
    if (!host.call('assistantFlyStartShown', root)) return false
  }
  if (!host.call('workspacePresetCanApply', root)) return false
  if (host.call('workspacePresetApplied', root)) return false
  Promise.resolve(host.call('workspacePresetsLoad')).catch(() => null)
  return true
}

// The line's press: the App Store, where the presets lead — opened the way
// every App Store open goes (a pane over the home).
export function assistantFlyFirstRunPresetOpen() {
  return this.call('openAppPage', '/marketplace?surface=appstore')
}
